const getLiteralText = (value, items)=>{
    const item1 = items.find((item)=>item.value === value
    );
    return item1 === null || item1 === void 0 ? void 0 : item1.title;
};

export { getLiteralText };
//# sourceMappingURL=get-literal-text.js.map
